import {
  formatNormalNumber,
  createKpiTileItem,
} from '../../../../utils/helper';
import { KpiHandler, ValueRealizationData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const noOfSites: KpiHandler = {
  type: 'KpiTile',
  handler: (data: ValueRealizationData): KpiData => {
    const { noOfSites } = data;

    const formattedValue = formatNormalNumber(noOfSites);

    return createKpiTileItem('Number of Sites', formattedValue, []);
  },
};

export default noOfSites;
